import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export function AppHeader() {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = async () => {
    await logout();
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-50 flex items-center justify-between whitespace-nowrap border-b border-border bg-card px-6 py-3">
      <Link to="/projects" className="flex items-center gap-3 text-foreground">
        <div className="size-8 flex items-center justify-center rounded-lg bg-primary/10 text-primary">
          <span className="material-symbols-outlined text-2xl">deployed_code</span>
        </div>
        <div className="flex items-baseline gap-2">
          <h2 className="text-lg font-bold leading-tight tracking-tight">BuildCrate</h2>
        </div>
      </Link>
      <div className="flex items-center gap-4">
        <button
          type="button"
          onClick={() => navigate("/profile")}
          className="text-muted-foreground hover:text-primary transition-colors"
          title="Profile"
        >
          <span className="material-symbols-outlined">person</span>
        </button>
        <button
          type="button"
          onClick={handleLogout}
          className="text-muted-foreground hover:text-destructive transition-colors"
          title="Logout"
        >
          <span className="material-symbols-outlined">logout</span>
        </button>
      </div>
    </header>
  );
}
